import { render, staticRenderFns } from "./SkillUsable.vue?vue&type=template&id=70f32b34&scoped=true&"
import script from "./SkillUsable.vue?vue&type=script&lang=ts&"
export * from "./SkillUsable.vue?vue&type=script&lang=ts&"
import style0 from "./SkillUsable.vue?vue&type=style&index=0&id=70f32b34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f32b34",
  null
  
)

export default component.exports